import { useEffect, useState } from 'react';

type UseFiltersDrawerProps = {
  appliedFilters: Record<string, any>;
};

const useFiltersDrawer = ({ appliedFilters }: UseFiltersDrawerProps) => {
  const [isFiltersDrawerOpen, setIsFiltersDrawerOpen] = useState(false);
  const [expandedFilters, setExpandedFilters] = useState<string[]>([]);
  const [advanceFilters, setAdvanceFilters] = useState(appliedFilters);

  const toggleFiltersDrawer = (isOpen?: boolean) => {
    const newIsFiltersDrawerOpen = isOpen !== undefined ? isOpen : !isFiltersDrawerOpen;
    if (!newIsFiltersDrawerOpen) setAdvanceFilters(appliedFilters);
    setIsFiltersDrawerOpen(newIsFiltersDrawerOpen);
  };

  const toggleExpandedFilter = (filterName: string) => {
    setExpandedFilters((prev) => {
      if (prev.includes(filterName)) {
        return prev.filter((f) => f !== filterName);
      } else {
        return [...prev, filterName];
      }
    });
  };

  const collapseAllFilters = () => {
    setExpandedFilters([]);
  };

  const updateAdvanceFilters = (newAdvanceFilters: { type: string; selections: any }) => {
    setAdvanceFilters((prev) => ({ ...prev, [newAdvanceFilters.type]: newAdvanceFilters.selections }));
  };

  useEffect(() => {
    setAdvanceFilters(appliedFilters);
  }, [appliedFilters]);

  return {
    isFiltersDrawerOpen,
    toggleFiltersDrawer,
    expandedFilters,
    toggleExpandedFilter,
    collapseAllFilters,
    advanceFilters,
    updateAdvanceFilters
  };
};

export default useFiltersDrawer;
